import { SecureTenantStore } from '@infra/persistence/SecureTenantStore';
import { TenantContext } from './TenantContext';

const KEY = 'compta.periodes_cloturees';

export class PeriodeComptaClotureeError extends Error {
  constructor(public readonly periode: string) {
    super(
      `La période ${periode} est clôturée. Déverrouillez-la pour modifier les écritures.`,
    );
    this.name = 'PeriodeComptaClotureeError';
  }
}

/** Garde dépôt : interdit toute mutation d’écriture sur une période clôturée (local + Cloud). */
export async function assertPeriodeComptaOuverte(periode: string): Promise<void> {
  if (!periode || !/^\d{4}-\d{2}$/.test(periode)) return;
  const tenantId = TenantContext.getInstance().tenantId();
  const raw = await SecureTenantStore.getJson<string[]>(tenantId, KEY, []);
  const cloturees = Array.isArray(raw) ? raw.filter((p) => /^\d{4}-\d{2}$/.test(p)) : [];
  if (cloturees.includes(periode)) {
    throw new PeriodeComptaClotureeError(periode);
  }
}

/** Sources d'écritures de clôture annuelle : elles se passent par construction en fin d'exercice. */
const SOURCES_CLOTURE_EXEMPTEES = new Set(['cloture', 'an']);

/**
 * Garde de dépôt branchée sur `ctx.ecritures` : TOUTE voie d'écriture comptable (saisie manuelle, paie,
 * factures, règlements, import, seed) est refusée dans une période clôturée. On corrige par extourne
 * imputée sur une période ouverte (voir `ExtournePaie`), jamais par modification.
 */
export async function gardeEcriturePeriodeCloturee(e: {
  periode: string;
  source?: string;
}): Promise<void> {
  if (e.source && SOURCES_CLOTURE_EXEMPTEES.has(e.source)) return;
  await assertPeriodeComptaOuverte(e.periode);
}
